export const dict = {
  iAmFatemeh: "I'm Fatemeh Rasolzadeh",
  frontEndDeveloper: "Front-End Developer",
  about1: "I'm a programmer, I make love with codes and live with my projects.",
  about2: "It's not just a job but a lifestyle, in fact I can't imagine life without it.",
  about3: "it's a never-ending world with new and tough challenges every day,",
  about4: "never before facing They are not afraid and exciting and attractive to me.",
  downloadCV: "<Download CV />",
  skill1: "I use the best and most up-to-date web technologies to create maintain and custom websites.",
  skill2:
    "Websites that are fully responsive and can be used on any device and user. I make the template using React or Next.",
  skill3: "Make them beautiful and attractive with design systems like css, scss, bootstrap, ...",
  skill4: "Make the site interactive by using API calls to get data from the server.",
  skillsAndExperience: "Skills & Experience",
  toolsAndRequirements: "Tools & requirements",
  tools1: "I need professional and trendy tools for coding, team work, testing and generating backend APIs,",
  tools2: "recording tasks I do and implementing the designer plan.",
  projects: "Projects",
  projects1: "I have worked with great teams on many projects. Including:",
  projects2: "ERP dashboard and corporate website at Aseman Sooye Parsian",
  projects3: "Operations management system, customer portal and Driver App at Boxit",
  projects4:
    "E-commerce website, admin panel, landing page, kiosk Application at Domil(Banimode, Jeanswest, Balcafe)",
  projects5:
    " We don't have access to the organizations' panels (because we're not their admins), but let's take a look at some of the public work together.",
};
